export const contentData = {
	displayModuleIds: ['exhibition:9576:1773738528834', 'exhibition:25957:1773741138276'],
	companyProfileContentIds:['exhibition:25957:1773741980311', 'exhibition:25957:1773741006793', 'exhibition:25957:1773902700494']
};
